import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./Login.css";
import { FiEye, FiEyeOff } from "react-icons/fi";

const Login = () => {
  const [formData, setFormData] = useState({
    emailOrId: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const SERVER_URL = "https://tas.itl.ng";

  const ADMIN_DASHBOARDS = {
    "super-admin": "/admin/dashboard",
    "state-admin": "/admin/state-dashboard",
    "sd-admin": "/admin/senatorial-dashboard",
    "fc-admin": "/admin/district-dashboard",
    "lga-admin": "/admin/lga-dashboard",
    "lcda-admin": "/admin/lcda-dashboard",
    "ward-admin": "/admin/ward-dashboard",
    "polling-unit-admin": "/admin/polling-unit-dashboard",
    "member": "/profile",
    "local-cordinator": "/profile",
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    if (!formData.emailOrId || !formData.password) {
      setError("Please fill in both fields");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        identifier: formData.emailOrId,
        password: formData.password,
      };

      const res = await fetch(`${SERVER_URL}/api/v1/auth/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok && data.status === "success") {
        const userData = data.data.user;
        const token = data.data.token;

        let redirectPath = "/profile";
        const primaryRole = userData.roles?.[0] || "member";
        redirectPath = ADMIN_DASHBOARDS[primaryRole] || "/profile";

        const isAdminUser = primaryRole.includes("admin");
        const adminRoleType = primaryRole.replace("-", " ").toUpperCase();

        const userWithRole = {
          ...userData,
          role: primaryRole,
          isAdminUser,
          adminRoleType,
        };

        login(userWithRole, token);
        localStorage.setItem("tokenExpires", Date.now() + 3600 * 1000);

        setShowSuccess(true);
        setTimeout(() => {
          navigate(redirectPath);
        }, 2000);
      } else {
        setError(
          data.message || "Invalid credentials. Please check your details."
        );
      }
    } catch (error) {
      setError("Network error. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccess(false);
    navigate("/profile");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="login-page">
      {/* Success Modal */}
      {showSuccess && (
        <div className="success-modal-overlay">
          <div className="success-modal">
            <div className="success-icon">✓</div>
            <h3>Welcome Back!</h3>
            <p>You have successfully logged in to your account.</p>

            <div className="success-progress">
              <div className="progress-bar">
                <div className="progress-fill"></div>
              </div>
              <span>Redirecting to your dashboard...</span>
            </div>
            <button className="success-close-btn" onClick={closeSuccessModal}>
              Go to Dashboard
            </button>
          </div>
        </div>
      )}

      <div className="login-container">
        <h2>Welcome Back Member</h2>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <label>Email or Membership ID</label>
          <input
            type="text"
            name="emailOrId"
            placeholder="Enter your Phone Number"
            value={formData.emailOrId}
            onChange={handleChange}
            disabled={loading}
          />

          <label>Password</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password@123"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />
            <div className="password-toggle" onClick={togglePasswordVisibility}>
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </div>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Signing In..." : "Sign In to Dashboard"}
          </button>
        </form>

        <p className="forgot">
          Forgot password? <Link to="/reset">Reset here</Link>
        </p>

        <p className="register">
          Not a member yet?{" "}
          <Link to="/register">Register to join the movement.</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
